import { render, staticRenderFns } from "./AbsentLetterTask.vue?vue&type=template&id=4b97cf52&scoped=true"
import script from "./AbsentLetterTask.vue?vue&type=script&lang=js"
export * from "./AbsentLetterTask.vue?vue&type=script&lang=js"
import style0 from "./AbsentLetterTask.vue?vue&type=style&index=0&id=4b97cf52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97cf52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b97cf52')) {
      api.createRecord('4b97cf52', component.options)
    } else {
      api.reload('4b97cf52', component.options)
    }
    module.hot.accept("./AbsentLetterTask.vue?vue&type=template&id=4b97cf52&scoped=true", function () {
      api.rerender('4b97cf52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/absent_letter_v3/components/AbsentLetterTask.vue"
export default component.exports